// Full Menu List Componenet
export default class MenuList extends React.Component {
    constructor(props) {
        super(props);
        this.sendUrlCategoryData = this.sendUrlCategoryData.bind(this);
    }
    
    sendUrlCategoryData(element,UrlData) {
        element.preventDefault();
        //update url
        
        history.pushState({}, "Menu", UrlData);
        this.props.sendUrlCategoryData(UrlData);
        $('.mdl-layout__content .brandSection.aboutBrand').css('display', 'none');
        $('.disclaimerList.mc-disclaimer').css('display', 'none');
        $('.disclaimerList.sc-disclaimer').css('display', 'block');
        $('.main-menus-topsection').css('display', 'none');
        let selectedLink = document.querySelector(".sub-navigation-primary-container a[href='" + UrlData + "']");
        if (selectedLink) {
            selectedLink.classList.add("_activeLink");
                $(".scrolling-menu-item-list a[href='"+UrlData+"']").focus();
            }
    }
    

    render() {
        return (
            <div className="col-md-4 col-sm-12 col-12 ihop-border">
                <a onClick={(e) => this.sendUrlCategoryData(e,this.props.cardUrl)} href={this.props.cardUrl} className="listing-card-item">
                    <div className="card-box">
                        <div className="row item-center">
                            <div className="col-6 card-descirption">
                                <div className="h4 card-heading">{this.props.menuCategoriesTitle}</div>
                            </div>
                            <div className="col-6 card-image">
                                <div className="img-section">
                                    <img src={this.props.menuCategoriesImage} className="ml-auto img-fluid" alt={"Example of IHOP "+this.props.menuCategoriesTitle} />
                                </div>
                            </div>
                        </div>                 
                    </div>
                </a>
            </div>
        );
    }
}
